import {ChangeDetectionStrategy, Component, Inject, Input} from "@angular/core";
import {Service} from "../../../models/service.model";

require('./service-agent-comment-indication.scss');
@Component({
  standalone: false,
  selector: 'app-service-agent-comment-indication',
  templateUrl: './service-agent-comment-indication.html',
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class ServiceAgentCommentIndicationComponent {
  @Input() service: Service;


  constructor(@Inject('deliveriesDialogService') private deliveriesDialogService) {
  }

  open(delivery, event) {
    event.stopPropagation();
    this.deliveriesDialogService.serviceInfo(delivery, event);
  }

}
